import { useEffect, useState } from 'react'

import { type OpenDockStopAppointment, type OpenDockWarehouseDetails } from '../../domain/Shipment'
import { Reschedule } from './Reschedule'
import { Scheduled } from './Scheduled'

const STEPS = {
  SCHEDULED: 'scheduled',
  RESCHEDULE: 'reschedule',
}

export function StepContent({
  isOpen,
  stopAppointment,
  warehouseDetails,
  facilityName,
  facilityTimezone,
  shipmentUUID,
  stopIndex,
  onCancelAppointment,
}: {
  isOpen: boolean
  stopAppointment?: OpenDockStopAppointment
  warehouseDetails?: OpenDockWarehouseDetails
  facilityName?: string
  facilityTimezone?: string
  shipmentUUID: string
  stopIndex: number
  onCancelAppointment: () => void
}) {
  const [step, setStep] = useState(STEPS.SCHEDULED)

  useEffect(() => {
    if (!isOpen) setStep(STEPS.SCHEDULED)
  }, [isOpen])

  switch (step) {
    case STEPS.SCHEDULED:
      return (
        <Scheduled
          onReschedule={() => setStep(STEPS.RESCHEDULE)}
          onCancelAppointment={onCancelAppointment}
          stopAppointment={stopAppointment}
          facilityName={facilityName}
          facilityTimezone={facilityTimezone}
          //@TODO: Get this value from the backend
          rescheduleByCarrierForbidden={false}
        />
      )
    case STEPS.RESCHEDULE:
      return (
        <Reschedule
          onReschedule={() => setStep(STEPS.SCHEDULED)}
          onBack={() => setStep(STEPS.SCHEDULED)}
          stopAppointment={stopAppointment}
          warehouseDetails={warehouseDetails}
          facilityName={facilityName}
          facilityTimezone={facilityTimezone}
          shipmentUUID={shipmentUUID}
          stopIndex={stopIndex}
        />
      )
    default:
      return null
  }
}
